<template>
  <span @click="openSupport">
    <slot></slot>
  </span>
</template>

<script>
// import { intercom } from '@/services';

export default {
  methods: {
    openSupport(event) {
      // Uncomment the following line to re-enable Intercom integration.
      // intercom.openIntercom.call(this, event);
      this.$store.commit('dialogue/open', 'support');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Utilities/SupportButton.vue